import { table } from "../models.model";

export const ADICLA_CONFIG: table = {
  columnas: [
    '',
    '1 a 30 días',
    '31 a 60 días',
    '61 a 90 días',
    '91 a 180 días',
    'más de 180 días',
    'Total'
  ],
  filas: [
    {
      type: 'titulo',
      id: 'TITULO_1',
      bandas: [0,0,0,0,0],
      descripcion: 'Cuentas'
    },{
      type: 'cuenta',
      id: 'A101',
      codigo: 'A101',
      bandas: [1,0,0,0,0],
      calculo: [1,0,0,0,0],
      descripcion: 'Disponibilidades',
      visible: false,
    },{
      type: 'valorComp',
      id: 'A102',
      codigo: 'A102',
      valorComparar: 'inversiones_1',
      bandas: [1,0,0,0,0],
      calculo: [1,0,0,0,0],
      descripcion: 'Inversiones hasta 30 días',
      comparacion: true,
      visible: false,
    },{
      type: 'subtotal',
      codigo: 'SUBTOTAL_01',
      sumar: ['A101', 'A102'],
      bandas: [1,0,0,0,0],
      calculo: [1,0,0,0,0],
      descripcion: 'Total activos líquidos',
      visible: true,
      expandible: true,
      expandido: false,
    },{
      type: 'valorComp',
      codigo: '',
      id: 'INVERSIONES_2',
      valorComparar: 'inversiones_2',
      bandas: [0,1,1,1,1],
      calculo: [0,1,1,1,1],
      descripcion: 'Inversiones > 30 días',
      visible: false,
    },{
      type: 'variableTemp',
      id: 'VT22',
      codigo: 'VT22',
      valorComparar: 'cuotas_1',
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Cartera neta',
      visible: false,
    },{
      type: 'ceros',
      id: 'CEROS_01',
      codigo: '',
      bandas: [0,0,0,0,0],
      calculo: [0,0,0,0,0],
      descripcion: 'Activo fijo neto',
      visible: false,
    },{
      type: 'ceros',
      id: 'CEROS_02',
      codigo: '',
      bandas: [0,0,0,0,0],
      calculo: [0,0,0,0,0],
      descripcion: 'Restos de activos',
      visible: false,
    },{
      type: 'subtotal',
      codigo: 'SUBTOTAL_02',
      sumar: ['INVERSIONES_2', 'VT22', 'CEROS_01', 'CEROS_02'],
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Total activos menos líquidos',
      visible: true,
      expandible: true,
      expandido: false,
    },{
      type: 'valorComp',
      id: 'FONDEO_1',
      codigo: '',
      valorComparar: 'fondeo_1',
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Fondeo',
      visible: false,
    },{
      type: 'editable',
      id: 'CREATE_1',
      codigo: 'VT09',
      bandas: [1,1,1,1,1],
      valorComparar: 'create_1',
      descripcion: 'Otros pasivos',
      editable: true,
      visible: false,
    },{
      type: 'ceros',
      id: 'CEROS_03',
      codigo: '',
      bandas: [0,0,0,0,0],
      calculo: [0,0,0,0,0],
      descripcion: 'Patrimonio total',
      visible: false,
    },{
      type: 'subtotal',
      codigo: 'SUBTOTAL_03',
      sumar: ['FONDEO_01', 'CREATE_1', 'CEROS_03'],
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Total pasivo y patrimonio',
      visible: true,
      expandible: true,
      expandido: false,
    },{
      type: 'ceros',
      id: 'CARTERA_01',
      codigo: '',
      valorComparar: 'cartera',
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Intereses de cartera neta',
      visible: false,
    },{
      type: 'ceros',
      id: 'CEROS_04',
      codigo: '',
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Intereses de depósitos a la vista',
      visible: false,
    },{
      type: 'valorComp',
      id: 'INVERSIONES_3',
      codigo: '',
      valorComparar: 'inversiones_3',
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Intereses de inversiones financieras',
      visible: false,
    },{
      type: 'valorComp',
      id: 'CREATE_2',
      codigo: '',
      valorComparar: 'create_2',
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Otros ingresos',
      ingresoManual: true,
      visible: false,
    },{
      type: 'subtotal',
      codigo: 'SUBTOTAL_04',
      sumar: ['CARTERA_01','CEROS_04','INVERSIONES_3','CREATE_2'],
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Total ingresos contractuales esperados',
      visible: true,
      expandible: true,
      expandido: false,
    },{
      type: 'valorComp',
      id: 'FONDEO_2',
      codigo: '',
      valorComparar: 'fondeo_2',
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Interes de fondeo',
    },{
      type: 'valorComp',
      id: 'CREATE_3',
      codigo: '',
      valorComparar: 'create_3',
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Gastos operativos y administrativos',
      ingresoManual: true,
      visible: false,
    },{
      type: 'valorComp',
      id: 'CREATE_4',
      codigo: '',
      valorComparar: 'create_4',
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Otros egresos',
      ingresoManual: true,
      visible: false,
    },{
      type: 'subtotal',
      codigo: 'SUBTOTAL_05',
      sumar: ['FONDEO_2','CREATE_3','CREATE_4'],
      bandas: [1,1,1,1,1],
      calculo: [1,1,1,1,1],
      descripcion: 'Total egresos contractuales esperados',
      visible: true,
      expandible: true,
      expandido: false,
    },{
      type: 'blank',
      id: '1',
      bandas: [0,0,0,0,0],
    }
  ]
}